import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'filters-toggle_sidebar_filters_pill-action_category_click';

/**
 * Track when the button that opens and hides the filter sidebar menu is clicked.

Params:
1. Action taken by clicking, either "close_filters" or "open_filters"
2. Number of active filters at time of clicking
3. Surface of filters, e.g. Search or Category
 */
export function trackFiltersToggleSidebarFiltersPillActionCategoryClick(
  Action: string,
  activeFiltersCount2: string,
  surfaceName3: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { Action, activeFiltersCount2, surfaceName3 },
  });
}
